module.exports = __webpack_public_path__ + "static/media/Blogging-bro.1c32fe35.svg";